/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import styled from "styled-components";

export const StyledItem = styled.div<{ $transform: string; $zIndex: number; $filter: string; $opacity: number }>`
  position: absolute;
  width: 500px;
  height: 400px;
  border-radius: 10px;
  transition: 0.5s;
  left: calc(50% - 250px);
  transform: ${(props) => props.$transform};
  z-index: ${(props) => props.$zIndex};
  filter: ${(props) => props.$filter};
  opacity: ${(props) => props.$opacity};
`;
